
import { DefaultLayers } from '../../../core/src/utils/Layers';
import ViewManager from '../../../core/src/utils/ViewManager';
import ReelGroup from '../../../core/src/views/ReelGroup';
import { Tween } from '../../../core/src/Tween';
import ErrorModel from '../../../core/src/model/ErrorModel';
import App from '../../../core/src/App';
import GameEvents from '../../../core/src/const/GameEvents';
import VendorSpinStartState from '../VendorSpinStartState';

export default class VendorSpinStartMSTState extends VendorSpinStartState {
    private allReelsStarted: boolean = false;
    private hasResponse: boolean = false;
    private exitDelayTween: Tween | null = null;

    public enter(): void {
        this.resetStateProps();
        this.assigneeReelGroupEvent();
        super.enter()
    }

    resetStateProps(): void {
        this.allReelsStarted = false;
        this.hasResponse = false;
    }

    assigneeReelGroupEvent(): void {
        ReelGroup.instance.once(
            GameEvents.ALL_REELS_STARTED,
            () => {
                this.allReelsStarted = true;
                this.exit()
            },
            this
        );
    }
    protected getMinSpinTimeExitDelay(): number {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        let delay = this.getMinTimeInState() - reelGroup.getSpinTimePassed();
        if (delay < 0) {
            delay = 0
        } else {
            delay = delay / 1000;
        }

        return delay
    }

    public getMinTimeInState(): number {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        let result = 0;
        result = (App.config.minSpinTime * 1000) - reelGroup.getSpinStopTime();

        if (result < 0) {
            result = 0;
        }

        return result
    }

    protected isMinSpinTimePassed(): boolean {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        return reelGroup.getSpinTimePassed() > this.getMinTimeInState()
    }

    public exit(): void {
        if ((this.allReelsStarted && this.hasResponse) || ErrorModel?.errorCode > 0) {
            if (this.isMinSpinTimePassed()) {
                this.allReelsStarted = false;
                this.hasResponse = false;
                super.exit();
            } else {
                this.exitDelayTween?.kill();
                this.exitDelayTween = Tween.delayedCall(this.getMinSpinTimeExitDelay(), () => this.exit());
            }
        }
    }

    startSpin() {
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        reelGroup.disableSwipeSpin();

        super.startSpin();
    }



    protected onResponse(data?:any) {
        this.hasResponse = true;
        super.onResponse(data)
    }

}
